module.exports = __webpack_public_path__ + "static/img/4.c638ca5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/408/4.png
// module id = 486
// module chunks = 1